var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('layout-loading'):(_vm.isCenterPage)?_c('LayoutCenter'):(_vm.existsDisplayName)?_c('layout-main'):_c('layout-auth')}
var staticRenderFns = []

export { render, staticRenderFns }